import { useCallback, useMemo } from "react";

import {
  ConfigurationApiInterface,
  ConfigurationSummary,
} from "@plansoft-configuration-renderer/configuration-api";
import {
  createConfigurationApi,
  useConfigurationMeta,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

export const getSummaryQueryKey = "summaryQueryKey";

export function useSummary(): UseQueryResult<ConfigurationSummary, Error> {
  const { baseUrl } = useConfigurationMeta();
  const sessionId = useSessionId();

  const cfgApi = useMemo((): ConfigurationApiInterface => {
    return createConfigurationApi({
      basePath: baseUrl,
      apiKey: "",
    });
  }, [baseUrl]);

  const summaryFetcher = useCallback(
    () => cfgApi.getSummary({ id: sessionId }),
    [cfgApi, sessionId],
  );

  return useQuery({
    queryKey: [getSummaryQueryKey],
    queryFn: summaryFetcher,
  });
}
